var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewMessageDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1365",
    "data-name": "Rectangle 1365",
    width: 16,
    height: 16,
    transform: "translate(-0.185 -0.185)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Write_a_message",
    "data-name": "Write a message",
    transform: "translate(0.185 0.185)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4171",
    "data-name": "Group 4171",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M12.1,8.867l5.879-5.9a1.3,1.3,0,0,0-1.83-1.836L10.261,7.044a.876.876,0,0,0-.213.351L9.332,9.631a.083.083,0,0,0,.092.1l2.3-.641A.867.867,0,0,0,12.1,8.867Z",
    transform: "translate(-3.223 -0.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M13.432,9.276v3.316a3.8,3.8,0,0,1-3.789,3.8h-5.1a3.8,3.8,0,0,1-3.789-3.8V7.469a3.8,3.8,0,0,1,3.789-3.8h4.01",
    transform: "translate(-0.259 -1.257)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewMessageDropIcon);
export default __webpack_public_path__ + "static/media/new-message-drop-icon.64fa201a5180295666348b816ab1f3f2.svg";
export { ForwardRef as ReactComponent };